import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'epc-scale-selector',
  templateUrl: './scale-selector.component.html',
  styleUrls: ['./scale-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ScaleSelectorComponent {
  @Input() public scales: string[];
  @Input() public selected: string;
  @Input() public scaleDisplayObject: { [key: string]: string };
  @Input() public disabled: boolean;

  @Output() public selectScale = new EventEmitter<string>();

  public trackByScale(_: number, scale: string) {
    return scale;
  }

  public handleSelect(scale: string) {
    this.selectScale.emit(scale);
    this.selected = scale;
  }
}
